export default "__VITE_ASSET__C5_WH85G__";